// import {CircleBufferGeometry} from "three";

import {
    BufferGeometry, Float32BufferAttribute, Vector2, Vector3
} from 'three';

export class HalfRoundedRect extends BufferGeometry {

    constructor(width = 3, height = 3, radius = 0.5, bendingRadius = 1, segments = 8, wSegments = 10) {

        super();

        this.type = 'HalfRoundedRect';

        this.parameters = {
            radius,
            height,
            width,
            segments,
            wSegments,
            bendingRadius
        };

        segments = Math.max(2, segments);
        wSegments = Math.max(2, wSegments);
        const dw2 = 0.5 * Math.max(width - radius * 2, 0);
        const halfH = 0.5 * height;
        const roundCY = (0.5 * height - radius);
        const bradius = bendingRadius;

        // buffers

        const indices = [];
        const vertices = [];
        const verticesXY = [];
        const normals = [];
        const uvs = [];

        // helper variables

        const vertex = new Vector3();
        const uv = new Vector2();

        let rad = 0;

        // Add indices of 4 triangles in the column
        const pushIndices = (i) => {
            if (i % 3 === 2) {
                indices.push(i + 2, i, i + 3);
            } else if (i % 3 === 1) {
                indices.push(i + 2, i, i + 3);
                indices.push(i + 1, i, i + 3);
            } else {
                indices.push(i, i + 3, i + 1);
            }
        };

        // LEFT
        // center point

        for (let s = 0; s <= segments; s += 1) {

            const segment = (0.5 + 0.5 * (s / segments)) * Math.PI;

            // vertex

            vertex.x = -dw2 + radius * Math.cos(segment);
            vertex.y = roundCY + radius * Math.sin(segment);

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            vertex.x = -dw2 - radius * (s / segments);
            vertex.y = roundCY;

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            vertex.x = -dw2 - radius * (s / segments);
            vertex.y = -halfH;

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            // normal

            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);

            // uvs

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

        }

        // indices

        for (let i = 0; i <= (segments * 3 - 1); i += 1) {

            pushIndices(i);

        }

        // RIGHT
        // center point

        for (let s = 0; s <= segments; s += 1) {

            const segment = 0.5 * ((segments - s) / segments) * Math.PI;

            // vertex

            vertex.x = dw2 + radius * Math.cos(segment);
            vertex.y = roundCY + radius * Math.sin(segment);

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            vertex.x = dw2 + radius * (s / segments);
            vertex.y = roundCY;

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            vertex.x = dw2 + radius * (s / segments);
            vertex.y = -halfH;

            rad = vertex.x / bradius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            // normal

            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);

            // uvs

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = (vertex.y / radius + 1) / 2;

            uvs.push(uv.x, uv.y);

        }

        // indices

        for (let i = (segments + 1) * 3; i <= 6 * segments + 3 - 1; i += 1) {

            pushIndices(i);

        }

        // CENTER
        for (let s = 0; s <= wSegments; s += 1) {

            // vertices

            vertex.x = dw2 * (1 - (s * 2) / wSegments);
            rad = vertex.x / bradius;

            vertex.y = roundCY + radius;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            vertex.y = roundCY;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            vertex.y = -halfH;
            vertices.push(bradius * Math.sin(rad), vertex.y, bradius * Math.cos(rad));
            verticesXY.push(vertex.x, vertex.y);

            // normal

            normals.push(0, 0, 1);
            normals.push(0, 0, 1);
            normals.push(0, 0, 1);

            // uvs

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = -0.5;

            uvs.push(uv.x, uv.y);

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = 0.5;

            uvs.push(uv.x, uv.y);

            uv.x = (vertex.x / radius + 1) / 2;
            uv.y = 0.5;

            uvs.push(uv.x, uv.y);

        }

        // indices
        for (let i = (segments + 1) * 6; i <= (vertices.length / 3) - 4; i += 1) {

            pushIndices(i);

        }

        // build geometry

        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('positionXY', new Float32BufferAttribute(verticesXY, 2));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    }

    static fromJSON(data) {

        return new HalfRoundedRect(data.radius, data.segments, data.wSegments);

    }

}
